import { TeamMemberRoles } from '@/entities/team'
import type { UserRole } from '@rundown-studio/types'
import type { FC } from 'react'
import AdvancedSelect from '../../../components/interactives/AdvancedSelect'
import { cn } from '@/utils'

type UserTeamRoleSelectProps = {
  value: UserRole
  onChange: (role: UserRole) => void
  className?: string
  loading?: boolean
  label?: string
}

export const UserTeamRoleSelect: FC<UserTeamRoleSelectProps> = ({
  value,
  onChange,
  className,
  loading,
  label,
}) => {
  return (
    <div className={cn('flex flex-col gap-0.5', className)}>
      {!!label && <label className="text-blue-500 text-xs">{label}</label>}

      <AdvancedSelect
        placeholder="Role"
        options={Object.entries(TeamMemberRoles).map(([key, role]) => {
          return {
            label: role.displayName,
            value: key,
            detail: role.description,
            // colorClassName: role.css,
          }
        })}
        value={value}
        setValue={onChange}
        loading={loading}
      />
    </div>
  )
}
